import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import styles from './ProfilesList.module.scss';

type ProfilesTableProps = React.PropsWithChildren<{
  /** Accessible name of the table (it has no header row, as the Document Vault table). */
  ariaLabel: string;
  isEmpty: boolean;
  emptyMessage: string;
}>;

/** List view of the Customers / Suppliers pages, styled as the Document Vault table. */
export const ProfilesTable = ({
  ariaLabel,
  isEmpty,
  emptyMessage,
  children,
}: ProfilesTableProps) => (
  <TableContainer
    component={Paper}
    className={styles.table_container}
    sx={{ backgroundColor: 'transparent', boxShadow: 'none', overflow: 'auto' }}
  >
    <Table className={styles.table} aria-label={ariaLabel}>
      <TableBody>
        {isEmpty ? (
          <TableRow>
            <TableCell colSpan={2} className={styles.empty_cell}>
              <p className={styles.empty_message}>{emptyMessage}</p>
            </TableCell>
          </TableRow>
        ) : (
          children
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

export default ProfilesTable;
